<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-toolbar
        color="primaryLight"
        dark
        dense
      >
        <v-toolbar-title>{{ accionDialog }}</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-form
          ref="form"
        >
          <v-container>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="dataForm.medio"
                  label="Medio*"
                  :rules="[globalRules.required]"
                  outlined
                  dense
                  class="compact"
                />
              </v-col>

              <v-col>
                <v-autocomplete
                  v-model="dataForm.tipoSelected"
                  label="Tipo*"
                  :items="tiposMedioOrdered"
                  item-text="TIPO"
                  item-value="TIPO"
                  return-object
                  :rules="[globalRules.required]"
                  outlined
                  dense
                  class="compact"
                  bottom
                />
              </v-col>
            </v-row>

            <v-row
              v-show="dataForm.tipoSelected && dataForm.tipoSelected.CATEGORIA === 'Aéreo'"
            >
              <v-col>
                <v-text-field
                  v-model="dataForm.velocidadMaxima"
                  label="Velocidad máxima (km/h)"
                  maxlength="9"
                  outlined
                  dense
                  class="compact"
                  hide-details
                />
              </v-col>
              <v-col>
                <v-text-field
                  v-model="dataForm.modelo"
                  label="Modelo"
                  outlined
                  dense
                  class="compact"
                  hide-details
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-text-field
                  v-model="dataForm.nombre"
                  label="Indicativo"
                  outlined
                  dense
                  class="compact"
                  hide-details
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-autocomplete
                  v-model="dataForm.baseSelected"
                  label="Base"
                  :items="bases"
                  item-text="NOMBRE"
                  item-value="NOMBRE"
                  return-object
                  outlined
                  dense
                  class="compact"
                  hide-details
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-text-field
                  v-model.number="dataForm.tiempoOperativo"
                  label="Tiempo operatividad(min)"
                  type="number"
                  outlined
                  dense
                  class="compact"
                  hide-details
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-text-field
                  v-model="dataForm.tlfInterno"
                  label="Teléfono interno"
                  maxlength="9"
                  outlined
                  dense
                  class="compact"
                  hide-details
                />
              </v-col>

              <v-col>
                <v-text-field
                  v-model="dataForm.tlfExterno"
                  label="Teléfono externo"
                  maxlength="9"
                  outlined
                  dense
                  class="compact"
                  hide-details
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-text-field
                  v-model.number="dataForm.tiempoTrabajo"
                  label="Tiempo trabajo en incendio(min)"
                  type="number"
                  outlined
                  dense
                  class="compact"
                  hide-details
                />
              </v-col>
              <v-col>
                <v-text-field
                  v-model.number="dataForm.tiempoDescanso"
                  label="Tiempo descanso obligatorio(min)"
                  type="number"
                  outlined
                  dense
                  class="compact"
                  hide-details
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-menu
                  ref="menuHoraEntrada"
                  v-model="showHoraEntrada"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                >
                  <template
                    #activator="{ on, attrs }"
                  >
                    <v-text-field
                      v-model="dataForm.horaEntrada"
                      label="Hora entrada*"
                      class="compact"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      outlined
                      dense
                      :rules="[globalRules.required]"
                      v-on="on"
                    />
                  </template>
                  <v-time-picker
                    v-show="showHoraEntrada"
                    v-model="dataForm.horaEntrada"
                    format="24hr"
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="primary"
                      @click="showHoraEntrada = false"
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menuHoraEntrada.save(dataForm.horaEntrada)"
                    >
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-menu>
              </v-col>

              <v-col>
                <v-menu
                  ref="menuHoraSalida"
                  v-model="showHoraSalida"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                >
                  <template
                    #activator="{ on, attrs }"
                  >
                    <v-text-field
                      v-model="dataForm.horaSalida"
                      label="Hora salida*"
                      class="compact"
                      prepend-icon="mdi-clock-time-four-outline"
                      readonly
                      v-bind="attrs"
                      outlined
                      dense
                      :rules="[globalRules.required]"
                      v-on="on"
                    />
                  </template>
                  <v-time-picker
                    v-show="showHoraSalida"
                    v-model="dataForm.horaSalida"
                    format="24hr"
                  >
                    <v-spacer />
                    <v-btn
                      text
                      color="primary"
                      @click="showHoraSalida = false"
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menuHoraSalida.save(dataForm.horaSalida)"
                    >
                      OK
                    </v-btn>
                  </v-time-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          color="red"
          @click="cancelar"
        >
          Cancelar
        </v-btn>
        <v-btn
          text
          color="green"
          :disabled="!isValid"
          @click="aceptar"
        >
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    show: Boolean,
    isEdit: Boolean,
    editedMedio: Object
  },

  data: () => ({
    isValid: false,
    showHoraEntrada: false,
    showHoraSalida: false,

    dataForm: {
      medio: null,
      velocidadMaxima: null,
      modelo: null,
      nombre: null, // "Indicativo"
      tlfInterno: null,
      tlfExterno: null,
      tiempoOperativo: null,
      horaEntrada: null,
      horaSalida: null,
      tiempoTrabajo: null,
      tiempoDescanso: null,
      tipoSelected: null,
      zonaSelected: null,
      baseSelected: null,
      comunidadAutonomaSelected: null,
      servicioSelected: null
    },

    globalRules: {
      required: value => !!value || 'Este campo es obligatorio'
    }
  }),

  computed: {
    ...mapGetters('medio', [
      'tiposMedio', 'comunidades_autonomas', 'servicios'
    ]),

    ...mapGetters('infraestructura', ['infraestructuras']),

    tiposMedioOrdered() {
      return [...this.tiposMedio].sort((a, b) => {
        if (!a.TIPO) return 1
        if (!b.TIPO) return -1
        return a.TIPO.localeCompare(b.TIPO)
      })
    },

    accionDialog() {
      return this.isEdit ? 'Editar' : 'Nuevo'
    },

    bases() {
      const bases = structuredClone(this.infraestructuras)
      bases.unshift({ ID_BASE: null, NOMBRE: 'Ninguna' })
      return bases.sort((a, b) => {
        if (a.NOMBRE === 'Ninguna' || b.NOMBRE === 'Ninguna') return 1
        if (!a.NOMBRE) return 1
        if (!b.NOMBRE) return -1
        return a.NOMBRE.localeCompare(b.NOMBRE)
      })
    },

    zonasMedio() {
      const zonas = JSON.parse(JSON.stringify(this.$store.getters['medio/zonas']))
      zonas.unshift({ ID_MEDIO_ZONA: null, ZONA: 'Ninguna' })
      return zonas.sort((a, b) => {
        if (a.ZONA === 'Ninguna' || b.ZONA === 'Ninguna') return 1
        if (!a.ZONA) return 1
        if (!b.ZONA) return -1
        return a.ZONA.localeCompare(b.ZONA)
      })
    }
  },

  watch: {
    show() {
      if (this.show) {
        if (this.isEdit) {
          this.dataForm.medio = this.editedMedio.MEDIO
          this.dataForm.tipoSelected = this.tiposMedio.find(x => x.TIPO === this.editedMedio.TIPO)
          this.dataForm.velocidadMaxima = this.editedMedio.VELOCIDAD_MAX
          this.dataForm.modelo = this.editedMedio.MODELO
          this.dataForm.nombre = this.editedMedio.NOMBRE
          const base = this.infraestructuras.find(x => x.NOMBRE === this.editedMedio.INFRAESTRUCTURA)
          this.dataForm.baseSelected = base || this.infraestructuras[0]

          if (base && base.ID_SERVICIO) {
            const servicio = this.servicios.find(s => s.ID_SERVICIO === base.ID_SERVICIO)
            const comunidad = this.comunidades_autonomas.find(
              c => c.ID_COMUNIDAD_AUTONOMA === servicio?.ID_COMUNIDAD_AUTONOMA
            )
            this.dataForm.servicioSelected = servicio || null
            this.dataForm.comunidadAutonomaSelected = comunidad || null
          } else {
            this.dataForm.servicioSelected = null
            this.dataForm.comunidadAutonomaSelected = null
          }

          this.dataForm.tlfInterno = this.editedMedio.TELEFONO_INTERNO
          this.dataForm.tlfExterno = this.editedMedio.TELEFONO_EXTERNO
          this.dataForm.horaEntrada = this.editedMedio.HORA_ENTRADA
          this.dataForm.horaSalida = this.editedMedio.HORA_SALIDA

          this.dataForm.tiempoOperativo = this.editedMedio.TIEMPO_OPERATIVO
          this.dataForm.tiempoTrabajo = this.editedMedio.TIEMPO_TRABAJO
          this.dataForm.tiempoDescanso = this.editedMedio.TIEMPO_DESCANSO
        }
      }
    },
    dataForm: {
      handler() {
        this.checkFormValidity()
      },
      deep: true
    },

    'dataForm.baseSelected': {
      handler(nuevaBase) {
        if (nuevaBase && nuevaBase.ID_SERVICIO) {
          const servicio = this.servicios.find(s => s.ID_SERVICIO === nuevaBase.ID_SERVICIO)
          const comunidad = this.comunidades_autonomas.find(
            c => c.ID_COMUNIDAD_AUTONOMA === servicio?.ID_COMUNIDAD_AUTONOMA
          )

          this.dataForm.servicioSelected = servicio || null
          this.dataForm.comunidadAutonomaSelected = comunidad || null
        } else {
          this.dataForm.servicioSelected = null
          this.dataForm.comunidadAutonomaSelected = null
        }
      },
      immediate: true
    }
  },

  methods: {
    checkFormValidity() {
      this.isValid =
        !!this.dataForm.medio &&
        !!this.dataForm.tipoSelected &&
        !!this.dataForm.horaEntrada &&
        !!this.dataForm.horaSalida
    },

    cancelar() {
      this.$refs.form.reset()
      this.$emit('cancelar')
    },

    aceptar() {
      const medio = this.isEdit ? JSON.parse(JSON.stringify(this.editedMedio)) : {}
      if (this.dataForm.tipoSelected.CATEGORIA === 'Aéreo') {
        medio.VELOCIDAD_MAX = this.dataForm.velocidadMaxima
        medio.MODELO = this.dataForm.modelo
      } else {
        medio.VELOCIDAD_MAX = null
        medio.MODELO = null
      }

      medio.MEDIO = this.dataForm.medio

      // Tipo / Categoria
      medio.TIPO = this.dataForm.tipoSelected.TIPO
      medio.CATEGORIA = this.dataForm.tipoSelected.CATEGORIA
      medio.ID_MEDIO_TIPO = this.dataForm.tipoSelected.ID_MEDIO_TIPO

      medio.NOMBRE = this.dataForm.nombre || null

      medio.TELEFONO_INTERNO = this.dataForm.tlfInterno || null
      medio.TELEFONO_EXTERNO = this.dataForm.tlfExterno || null

      // Zona
      medio.ZONA = this.dataForm.zonaSelected?.ZONA === 'Ninguna' ? '' : this.dataForm.zonaSelected?.ZONA || null
      medio.ID_MEDIO_ZONA = this.dataForm.zonaSelected?.ID_MEDIO_ZONA || null

      // medio.GUARDIAS = this.dat  aForm.guardias

      // Base
      medio.BASE = this.dataForm.baseSelected?.NOMBRE === 'Ninguna' ? '' : this.dataForm.baseSelected?.NOMBRE || null
      medio.ID_INFRAESTRUCTURA = this.dataForm.baseSelected?.ID_INFRAESTRUCTURA === '' ? 'NULL' : this.dataForm.baseSelected?.ID_INFRAESTRUCTURA || null
      medio.INFRAESTRUCTURA = this.dataForm.baseSelected?.NOMBRE === 'Ninguna' ? '' : this.dataForm.baseSelected?.NOMBRE || null
      medio.HORA_ENTRADA = this.dataForm.horaEntrada
      medio.HORA_SALIDA = this.dataForm.horaSalida

      // Dispositivo y servicio
      medio.SERVICIO = this.dataForm.servicioSelected?.LITERAL || null
      medio.ID_SERVICIO = this.dataForm.servicioSelected?.ID_SERVICIO || null
      medio.COMUNIDAD_AUTONOMA = this.dataForm.comunidadAutonomaSelected?.LITERAL || null
      medio.ID_COMUNIDAD_AUTONOMA = this.dataForm.comunidadAutonomaSelected?.ID_COMUNIDAD_AUTONOMA || null

      // Tiempos
      medio.TIEMPO_OPERATIVO = this.dataForm.tiempoOperativo || null
      medio.TIEMPO_TRABAJO = this.dataForm.tiempoTrabajo || null
      medio.TIEMPO_DESCANSO = this.dataForm.tiempoDescanso || null

      if (this.isEdit) {
        this.$emit('editMedio', medio)
      } else {
        medio.ID_MEDIO = this.$uuid.createUUID()
        medio.ESTADO = 24
        this.$emit('addMedio', medio)
      }

      this.$refs.form.reset()
    }
  }
}
</script>

<style scoped>
.compact ::v-deep(.v-text-field__details){
  height: fit-content;
  margin: 0;
}
</style>
